import { Globe } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { LANGS } from "../i18n/translations";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";

export default function LanguageSwitcher({ variant = "light" }) {
  const { lang, setLang } = useI18n();
  const current = LANGS.find((l) => l.code === lang);
  const dark = variant === "dark";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher"
          className={`flex items-center gap-2 px-3 py-2 text-sm transition-colors ${
            dark ? "text-bone/80 hover:text-bone" : "text-midnight hover:text-gold"
          }`}
        >
          <Globe className="h-4 w-4" strokeWidth={1.5} />
          <span className="uppercase">{current?.code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-none bg-white border-sand min-w-[160px]">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`cursor-pointer text-sm ${l.code === lang ? "text-gold font-medium" : "text-midnight"}`}
          >
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
